<template>
  <div>
    <v-dialog v-model="reschedule.dialog"
              max-width="900px"
              class="reschedule-dialog">
    <v-layout class="toolbar pa-4">
        
      <!-- <v-flex xs4
              class="fix-height">
        <p class="mt-3 mb-0 font-weight-bold tool-bar-texts blue-title">
          Training Time:
        </p>
        <span class="red--text" v-if="!this.$store.state.processTraining.selects.length > 0">This field is required.</span>
      </v-flex> -->
      <v-flex class="text-xs-center title blue-title font-weight-bold"
              xs12>
        Training Time
      </v-flex>
    </v-layout>
    <v-progress-linear indeterminate
                       v-if="loading"></v-progress-linear>
    <div class="calendar-card">
        <div class="week-calendar-container calendar-process">
            <div class="switch-date">
                  <v-tooltip bottom v-show="addCount > 0">
                    <v-btn @click="prevWeek()"
                            fab
                            slot="activator"
                            small>
                    <i class="material-icons white--text">keyboard_arrow_left</i>
                    </v-btn>
                    <span>Previous</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <v-btn @click="nextWeek"
                            fab
                            slot="activator"
                            small>
                    <i class="material-icons white--text">keyboard_arrow_right</i>
                    </v-btn>
                    <span>Next</span>
                </v-tooltip>
                </div>
                <fullcalendar-wrapper :calendar.sync="fullCalendarW"
                                    :events="calendarEvents"
                                    :options="weekOption1"
                                    @fetchingEvents="setViewRange"
                                    :eventRender="weekCalendarEvent"
                                    class="week-calendar-items"></fullcalendar-wrapper>
        </div>
    </div>
    <v-layout class="mt-3 px-3">
        <v-flex xs12 md12 lg12>
          <v-form ref="form">
            <v-text-field 
                        v-model="RescheduleReason"
                        outline
                        single-line
                        placeholder="Reschedule reason (within 100 characters)*"
                        :rules="textRule"
                        >
            </v-text-field>
          </v-form>
        </v-flex>
    </v-layout>
    <v-layout class="toolbar py-3"
              align-center
              justify-space-between>
      <v-flex class="text-xs-center title"
              xs12 md12 lg12>
        <v-btn class="white--text text-none cancel-button"
                  @click="reschedule.dialog = false">Cancel</v-btn>
        <v-btn class="text-none red-button dialog-submit"
               :disabled="!(canSubmit && RescheduleReason)"
               :loading="submitLoading"
               @click="enSureReschedule">Submit</v-btn>
      </v-flex>
    </v-layout>
    </v-dialog>
  </div>
</template>
<script>

// 可选时间：浅黄色

import fullcalendarWrapper from '@/components/fullcalendarWrapper'
import timeGridPlugin from '@fullcalendar/timegrid'
import '@fullcalendar/timegrid/main.css'
import weekCalendarEvent from './weekCalendarProcessEvent'
import dateFilter from '@/filters/dateFilter'
import { formatDate } from '@/utils/date.js'
import { createNamespacedHelpers } from 'vuex'
import store from '@/store'


const namespace = 'processTraining'
const { mapGetters, mapActions } = createNamespacedHelpers(namespace)

export default {
  components: { fullcalendarWrapper },
  name: 'process-calendar',
  data () {
    return {
      fullCalendarW: null,
      // weekViewSpan: 0,
      options: {
        plugins: [timeGridPlugin],
        defaultView: 'timeGridSevenDays',
        columnHeader: true,
        columnHeaderHtml: function(date) {
          var week = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
          let weekday = date.getDay()
          let dates = formatDate(date, 'MM/dd')
          return `<span class="calendar-title">${week[weekday]}</span>${dates}`
        },
        columnHeaderFormat: {
          weekday: 'short', 
          month: 'numeric', 
          day: 'numeric', 
          omitCommas: true 
        },
        height: '500',
        contentHeight: '500',
        aspectRatio: 2.5,
        allDaySlot: false,
        header: false,
        slotLabelFormat: (e)=>{
            if(e.start.hour===0){
                return ''
            }
            return `${(e.start.hour<10?`0${e.start.hour}`:e.start.hour)}:00-${(e.start.hour+3)}:00`
           
        },
        views: {
          timeGridSevenDays: {
            type: 'timeGridWeek',
            duration: { days: 7 },
          }
        },
        eventBackgroundColor: 'transparent',
        eventBorderColor: 'transparent',
        slotDuration:"01:00:00"
      },
      weekCalendarEvent,
      limitDay: 7, 
      addCount: 0,

      textRule: [
        v => !!v || 'required',
        v => (v && v.length <= 100) || 'The maximum number of input characters has been reached.'
        ],
      RescheduleReason:'',
    }
  },
  props:{
    reschedule:{
        dialog:false,
        currentTime:''
    }
  },
  filters: {
    dateFilter
  },
  computed: {
    ...mapGetters(['events', 'currentDate', 'loading', 'viewRange', 'hadInited', 'selects', 'errorText','submitLoading']),
    calendarEvents (dialog, msg) {
      return this.events.map(e => {
        return {
          start: e.ScheduleStart,
          end: e.ScheduleEnd,
          // 为了带进fullcalendar里  必须处理一下格式
          extendedProps: {
            ...e
          }
        }
      })

    },
    weekOption1 () {
      return Object.assign({}, this.options, {
        minTime: '08:00',
        maxTime: '21:00',
      })
    },
    canSubmit () {
      return this.$store.state[namespace].selects.length > 0 && this.$store.state[namespace].canSubmit
    },
  },
  watch: {
    currentDate () {
      // 日视图,切换日期的时候周日历不重复渲染事件,一次一百多个太卡了
      (this.currentDate > this.viewRange.end || this.currentDate < this.viewRange.start) && this.fullCalendarW.gotoDate(this.currentDate)
    },
    errorText (value) {
      if(value){
        if(value.Code===0){
          this.$root.$alertTips(value.ErrorMsg, 'success').then(()=>{
            this.reschedule.dialog = false;
            this.$emit('updatePTList');
          })
        }else{
          this.$root.$alertTips(value.ErrorMsg, 'error')
        }
        this.$store.dispatch(`${namespace}/setErrorText`, '')
      }
    }
  },
  async mounted () {
    if (this.hadInited) {
      // 若store中已存在数据, 切换到该页面时不会触发fetchData
      // 需要手动更新一下
      this.fetchData()
    }
    await this.fullCalendarW && this.fullCalendarW.gotoDate(this.currentDate)
    
    
    window.onresize = () => {
      this.setSwitchDatePosition()
    };
      
    this.setSwitchDatePosition()

    this.setCurrentDate(new Date()) //初始化日期
  },
  methods: {
    ...mapActions(['prev', 'next', 'setViewRange', 'fetchData', 'addSchedule', 'setErrorText', 'setCurrentDate', 'setRescheduleReason', 'setUserName']),

    enSureReschedule () {
      if (!this.$refs.form.validate()) {
          return
      }
      // setErrorText
      this.$root.$confirm(
        `Are you sure to reschedule Training?<br>
        Current training time：${this.reschedule.currentTime}<br>
        Modified training time：${formatDate(this.$store.state[namespace].selects[0].ScheduleStart,'MM-dd-yyyy hh:mm')}-${formatDate(this.$store.state[namespace].selects[0].ScheduleEnd,'hh:mm')}`,
         '',
         {icon:{default:true}}
         )
         .then((isOk) => {
        if (!isOk) return
        this.setRescheduleReason(this.RescheduleReason)
        this.setUserName(this.$store.state.user.fullName)
        this.addSchedule()
      })
    },
    nextWeek () {
      this.addCount++
      this.next()
    },
    prevWeek () {
      this.addCount--
      this.prev()
    },
    setSwitchDatePosition() {
      let calendarContainer = document.getElementsByClassName("week-calendar-container")[0]

      this.$nextTick(()=>{
        document.getElementsByClassName("switch-date")[0].style.width = calendarContainer.offsetWidth + "px"
        document.getElementsByClassName("switch-date")[0].style.height = calendarContainer.offsetHeight + "px"

      })
    }
  },
  destroyed() {
    window.onresize = null;
  },
  handleDateClick(calEvent){
    console.log(calEvent)
  }
}
</script>
<style scoped>
.fix-height {
  height: 52px;
}
.toolbar {
  padding-top: 5px;
  padding-left: 1em;
  padding-right: 2em;
}
.calendar-items {
  display: inline-block;
  width: 33%;
}
.week-calendar-container {
  white-space: nowrap;
}
.week-calendar-items {
  display: inline-block;
  width: 100%;
}
</style>
<style>
.fc-time-grid .fc-slats td {
  height: 3em;
  border-bottom: 0;
  text-align: center;
}
.fc-time-grid-event {
  height: 3.2em;
  overflow: visible;
  width: 100%;
  margin: 0;
  left: 0% !important;
  right: 0% !important;
}
.weekview-timespan--active {
  color: white !important;
  background-color: #1e88e5 !important;
}
.tool-bar-text,.tool-bar-texts{
  cursor: pointer;
  padding-left: 16px;
  position: relative;
}
.tool-bar-text::before, .tool-bar-texts::before{
    content: "\25CF";
    color: #EE344C !important;
    position: absolute;
    left: 0;
    font-size: 18px;
    top: -4px;
}
.tool-bar-texts::before{
  color: #EE344C !important;
}
.calendar-process{
  height: 350px;
  overflow-y: auto;
}
.calendar-process .fc-unthemed td.fc-today{
  background: rgba(255, 224, 116, 0.2)!important;
}
</style>
<style lang="scss" scoped>
.switch-date {
  position: absolute;
  width: 860px !important;
  height: 350px !important;
  .v-tooltip {
    position: absolute;
    top: 45%;
    left: -23px;
    z-index: 203;
    &:last-child{
      right: -23px;
      left: auto
    }
    .v-btn--floating.v-btn--small{
      width: 30px;
      height: 30px;
      background: #FFE074;
      border-radius: 4px;
      .v-icon{
        font-size: 30px;
        line-height: 30px;
        color: #fff;
      }
    }
  }
}
.calendar-card{
  box-shadow: 0px 0px 10px rgba(125, 162, 255, 0.19)!important;
  border-radius: 8px!important;
  @include font_color($font-color-theme);
  margin-left:20px;
  margin-right:20px;
}
.calendar-title{
  color: #F69898;
  font-size: 18px;
  font-weight: bold;
  margin-right: 5px;
  margin: 4px 0;
  padding-right: 7px;
  display: inline-block;
}

</style>
